import React, { useState, useEffect } from "react";

import { Row, Col, Input, Pagination } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";
import moment from "jalali-moment";
// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Approvals/Approvals.css";

const contactInput = {
  textAlign: "right",
  direction: "rtl",
  fontFamily: "IranSans",
  fontSize: ".85em",
  borderRadius: "12.5px",
};
const contactInputTablet = {
  textAlign: "right",
  direction: "rtl",
  paddingRight: "30px",
  fontFamily: "IranSans",
  fontSize: ".85em",
  borderRadius: "15px",
};
const contactInputMobile = {
  textAlign: "center",
  direction: "rtl",
  fontFamily: "IranSans",
  fontSize: ".8em",
  borderRadius: "15px",
};
const searchCard = {
  borderRadius: "20px",
  backgroundColor: "#fff",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
  opacity: "90%",
};

const ApprovalsSearch = (props) => {
    useEffect(()=>{
        console.log(moment().locale("fa").format("YYYY-MM-DD"))
    },[])
  const [startDate, setStartDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment().format("YYYY-MM-DD")
  );
  const [title, setTitle] = useState("");

  const submitStartDate = ({ value }) => {
    console.log("value ", value);
    setStartDate(value._i.substring(0, value._i.length - 3));
  };
  const submitEndDate = ({ value }) => {
    console.log("value ", value);
    setEndDate(value._i.substring(0, value._i.length - 3));
  };
  return props.size === "laptopdesktop" ? (
    <div style={searchCard}>
      <Center>
        <Margin top={3}>
          <div>
            <p className="cardTitle">
              <strong>جستجو در میان مصوبات</strong>
            </p>
          </div>
        </Margin>
      </Center>
      <Center>
        <hr style={{
          border: ".1em solid #e13024",
          width: "50%",
          marginTop: "-10px"
        }}/>
      </Center>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
          <Input
            style={contactInput}
            placeholder="عنوان"
            value={title}
            onChange={(e) => {
                e.preventDefault();

                setTitle(e.target.value)
            }}
          />
        </Col>
        <Col span={3}></Col>
      </Row>
      <Margin top={3}></Margin>
      <p
        style={{
          direction: "rtl",
          textAlign: "center",
          fontFamily: "IranSans",
          fontSize: ".85em",
        }}
      >
        از تاریخ:
      </p>
      <div style={{ marginTop: "-30px", textAlign: "center" }}>
        <DatePicker
         
          className="dp__input"
          timePicker={false}
          onClickSubmitButton={submitStartDate}
        />
      </div>
      <Margin top={2}></Margin>
      <p
        style={{
          direction: "rtl",
          textAlign: "center",
          fontFamily: "IranSans",
          fontSize: ".85em",
        }}
      >
        تا تاریخ:
      </p>
      <div style={{ marginTop: "-30px", textAlign: "center" }}>
        <DatePicker
          className="dp__input"
          timePicker={false}
          onClickSubmitButton={submitEndDate}
        />
      </div>
      <Margin top={3}></Margin>
      <Row>
        <Col span={4}></Col>
        <Col span={16}>
          <Row>
            <Col span={12}>
              <Margin bottom={3}>
                <a
                  onClick={() => props.search(title, startDate, endDate)}
                  class="introBtn introBtn-white introBtn-animated"
                  style={{
                    fontSize: ".8em",
                    fontFamily: "IRANSans",
                    paddingRight: "15px",
                    paddingLeft: "15px",
                    paddingTop: "2.5px",
                    paddingBottom: "2.5px",
                    color:"#fff",
                    borderRadius:"10px"
                  }}
                >
                  جستجو
                </a>
              </Margin>
            </Col>
            <Col span={12} style={{ direction: "rtl", textAlign: "right" }}>
              <Margin top={1}>
                <p
                  style={{
                    fontFamily: "IranSans",
                    color: "rgb(148, 148, 148)",
                    fontSize: ".85em",
                  }}
                >
                  تعداد نتایج: <span style={{ color: "#ed1c24" }}>{props.approvals}</span>
                </p>
              </Margin>
            </Col>
          </Row>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div style={searchCard}>
        <Center>
          <Margin top={3}>
            <div>
              <p className="cardTitleTablet">
                <strong>جستجو در میان مصوبات</strong>
              </p>
            </div>
          </Margin>
        </Center>
        <Center>
          <hr style={{
            border: ".1em solid #e13024",
            width: "50%",
            marginTop: "-10px"
          }} />
        </Center>
        <Row>
          <Col span={3}></Col>
          <Col span={18}>
            <Input
              style={contactInputTablet}
              placeholder="عنوان"
              value={title}
              onChange={(e) => {
                e.preventDefault();

                setTitle(e.target.value)
              }}
            />
          </Col>
          <Col span={3}></Col>
        </Row>
        <Margin top={3}></Margin>
        <p
          style={{
            direction: "rtl",
            textAlign: "center",
            fontFamily: "IranSans",
            fontSize: ".8em",
          }}
        >
          از تاریخ:
      </p>
        <div style={{ marginTop: "-30px", textAlign: "center" }}>
          <DatePicker
            className="dp__input"
            timePicker={false}
            onClickSubmitButton={submitStartDate}
          />
        </div>
        <Margin top={2}></Margin>
        <p
          style={{
            direction: "rtl",
            textAlign: "center",
            fontFamily: "IranSans",
            fontSize: ".8em",
          }}
        >
          تا تاریخ:
      </p>
        <div style={{ marginTop: "-30px", textAlign: "center" }}>
          <DatePicker
            className="dp__input"
            timePicker={false}
            onClickSubmitButton={submitEndDate}
          />
        </div>
        <Margin top={3}></Margin>
        <Row>
          <Col span={4}></Col>
          <Col span={16}>
            <Row>
              <Col span={12}>
                <Margin bottom={3}>
                  <a
                    onClick={() => props.search(title, startDate, endDate)}
                    class="introBtn introBtn-white introBtn-animated"
                    style={{
                      fontSize: ".75em",
                      fontFamily: "IRANSans",
                      paddingRight: "15px",
                      paddingLeft: "15px",
                      paddingTop: "2.5px",
                      paddingBottom: "2.5px",
                      color:"#fff",
                      borderRadius:"10px"
                    }}
                  >
                    جستجو
                </a>
                </Margin>
              </Col>
              <Col span={12} style={{ direction: "rtl", textAlign: "right" }}>
                <Margin top={1}>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      color: "rgb(148, 148, 148)",
                      fontSize: ".75em",
                    }}
                  >
                    تعداد نتایج: <span style={{ color: "#ed1c24" }}>{props.approvals}</span>
                  </p>
                </Margin>
              </Col>
            </Row>
          </Col>
          <Col span={4}></Col>
        </Row>
      </div>
  ) : (
        <div style={searchCard}>
          <Center>
            <Margin top={3}>
              <div>
                <p className="cardTitleMobile">
                  <strong>جستجو در میان مصوبات</strong>
                </p>
              </div>
            </Margin>
          </Center>
          <Center>
            <hr style={{
              border: ".1em solid #e13024",
              width: "50%",
              marginTop: "-10px"
            }} />
          </Center>
          <Row>
            <Col span={2}></Col>
            <Col span={20}>
              <Input
                style={contactInputMobile}
                placeholder="عنوان"
                value={title}
                onChange={(e) => {
                  e.preventDefault();

                  setTitle(e.target.value)
                }}
              />
            </Col>
            <Col span={2}></Col>
          </Row>
          <Margin top={3}></Margin>
          <p
            style={{
              direction: "rtl",
              textAlign: "center",
              fontFamily: "IranSans",
              fontSize: ".75em",
            }}
          >
            از تاریخ:
      </p>
          <div style={{ marginTop: "-30px", textAlign: "center" }}>
            <DatePicker
              
              className="dp__input"
              timePicker={false}
              onClickSubmitButton={submitStartDate}
            />
          </div>
          <Margin top={2}></Margin>
          <p
            style={{
              direction: "rtl",
              textAlign: "center",
              fontFamily: "IranSans",
              fontSize: ".75em",
            }}
          >
            تا تاریخ:
      </p>
          <div style={{ marginTop: "-30px", textAlign: "center" }}>
            <DatePicker
              className="dp__input"
              timePicker={false}
              onClickSubmitButton={submitEndDate}
            />
          </div>
          <Margin top={3}></Margin>
          <Row>
            <Col span={4}></Col>
            <Col span={16}>
              <Row>
                <Col span={12}>
                  <Margin bottom={3}>
                    <a
                      onClick={() => props.search(title, startDate, endDate)}
                      class="introBtn introBtn-white introBtn-animated"
                      style={{
                        fontSize: ".7em",
                        fontFamily: "IRANSans",
                        paddingRight: "15px",
                        paddingLeft: "15px",
                        paddingTop: "2.5px",
                        paddingBottom: "2.5px",
                        color:"#fff",
                        borderRadius:"10px"
                      }}
                    >
                      جستجو
                </a>
                  </Margin>
                </Col>
                <Col span={12} style={{ direction: "rtl", textAlign: "right" }}>
                  <Margin top={1}>
                    <p
                      style={{
                        fontFamily: "IranSans",
                        color: "rgb(148, 148, 148)",
                        fontSize: ".75em",
                      }}
                    >
                      تعداد نتایج: <span style={{ color: "#ed1c24" }}>{props.approvals}</span>
                    </p>
                  </Margin>
                </Col>
              </Row>
            </Col>
            <Col span={4}></Col>
          </Row>
        </div>
  );
};

export default ApprovalsSearch;
